import { TransactionTypeDto } from './dtos/transactions'

export const enum TransactionType {
  Payment = 'Payment',
  Abatement = 'Abatement',
}

export function parseTransactionType(dto: TransactionTypeDto): TransactionType {
  switch (dto) {
    case 'PAYMENT':
      return TransactionType.Payment
    case 'ABATEMENT':
      return TransactionType.Abatement
  }
  console.warn('Unknown transaction type', dto)
  return TransactionType.Payment
}

export function serializeTransactionType(
  type: TransactionType
): TransactionTypeDto {
  switch (type) {
    case TransactionType.Payment:
      return 'PAYMENT'
    case TransactionType.Abatement:
      return 'ABATEMENT'
  }
}
